import type { CustomFilterGroupLabelCreator } from '@/app/common/filters/core/filterComponentType.ts';
import type { Filter, FiltersGroup } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { StarsSelectionLabel } from '@/app/common/filters/surfaces/labels/StarsSelectionLabel.tsx';
import { PriceRangeSelectionLabel } from '@/app/common/filters/surfaces/labels/PriceRangeSelectionLabel.tsx';

// How a filter describes its whole selection, overriding the type-level "first value +N".
// Creators render the selected state only — each surface supplies its own chrome.
const SELECTION_LABEL_CREATORS: Record<string, CustomFilterGroupLabelCreator> = {
  [FILTER_NAME.STARS]: StarsSelectionLabel,
  [FILTER_NAME.PRICE_RANGE]: PriceRangeSelectionLabel,
};

export const selectionLabelOf = (filterName?: string): CustomFilterGroupLabelCreator | undefined =>
  filterName ? SELECTION_LABEL_CREATORS[filterName] : undefined;

/** A group is named by its first filter, whatever its surface or selected state. */
export const selectionLabelForGroup = (group: Pick<FiltersGroup, 'filters'>) =>
  selectionLabelOf(group.filters[0]?.name);

export const selectionLabelForFilters = (filters: Filter[]) => selectionLabelOf(filters[0]?.name);
